module.exports = __webpack_public_path__ + "images/header-harmonie-muenchen-latschenkopf-huette-c704328cd0bf05d6ec2b3c77e5c58504.jpg";